import { Announcement } from '@/shared/types/announcement';

/**
 * Communiqués mock (mode `NEXT_PUBLIC_API_IMPL=mock`). Reproduit la forme de
 * `GET /me/announcements`. Le handler mock filtre par audience + tag et trie
 * (épinglés puis récents).
 */
export const announcements: Announcement[] = [
  {
    id: 'ann-1',
    title: 'Bienvenue sur votre nouvel espace Suivora',
    description: 'Retrouvez ici vos CRA, notes de frais, documents…',
    content:
      '## Bienvenue 👋\n\nVotre espace **Suivora** centralise votre quotidien :\n\n- **CRA** — déclarez et soumettez vos activités\n- **Notes de frais** — ajoutez vos justificatifs\n- **Documents** — coffre-fort, à signer, reçus\n\nBonne prise en main !',
    audience: 'ALL',
    tags: ['Général', 'Outils'],
    pinned: true,
    read: true,
    authorName: 'Admin Suivora',
    publishedAt: '2026-07-01T08:00:00.000Z',
  },
  {
    id: 'ann-2',
    title: 'Congés d’été : transmettez vos dates',
    description: 'Merci de communiquer vos dates de congés avant le 15 juillet.',
    content:
      '## ☀️ Congés d’été\n\nMerci de transmettre vos dates de congés **avant le 15 juillet** afin d’organiser la continuité de service.',
    audience: 'CONSULTANT',
    tags: ['Congés', 'RH'],
    pinned: false,
    read: false,
    authorName: 'Mélanie Spillers',
    publishedAt: '2026-06-20T09:00:00.000Z',
  },
  {
    id: 'ann-3',
    title: 'Alternants — calendrier de l’année',
    description: 'Le rythme entreprise / école pour la rentrée.',
    content:
      '## Rentrée alternance\n\nVotre **rythme d’alternance** est disponible dans votre profil. Pensez à saisir vos jours école dans le CRA.',
    audience: 'INTERNAL',
    tags: ['Alternance', 'École', 'CRA'],
    pinned: false,
    read: false,
    authorName: 'Admin Suivora',
    publishedAt: '2026-06-10T10:00:00.000Z',
  },
];
